import React from 'react';
import ProductAdvertising from '../../../components/ProductAdvertising';
import { useIntl } from 'react-intl';

const Socials = () => {

    const textTranslator = useIntl();

    const data = {
        id: 34,
        id_en: 329,
        context: 'socials',
        title: textTranslator.formatMessage({ id: 'products.blocs.socials' })
    }
    return (
        <div>
            <ProductAdvertising data={data} />
        </div>
    );
};

export default Socials;